import React, { memo } from 'react';
import classnames from 'classnames/bind';
import { ExpandingPanel } from "../ExpandingPanel";
import styles from "./styles.pcss";
var cn = classnames.bind(styles);
export var Accordion = /*#__PURE__*/memo(function (_ref) {
  var items = _ref.items,
    PanelContent = _ref.panelContent,
    _ref$testName = _ref.testName,
    testName = _ref$testName === void 0 ? 'Accordion' : _ref$testName,
    size = _ref.size,
    _ref$withLastBorder = _ref.withLastBorder,
    withLastBorder = _ref$withLastBorder === void 0 ? false : _ref$withLastBorder;
  return /*#__PURE__*/React.createElement("ul", {
    className: cn('accordion'),
    "data-component": testName
  }, items.map(function (item) {
    return /*#__PURE__*/React.createElement("li", {
      className: cn('accordion__item', {
        'last-border': withLastBorder
      }),
      key: item.title
    }, /*#__PURE__*/React.createElement(ExpandingPanel, {
      size: size,
      title: item.title
    }, /*#__PURE__*/React.createElement(PanelContent, {
      data: item.content
    })));
  }));
});
Accordion.displayName = Accordion.name;